import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Search, ArrowRight } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "./ui/dialog";
import { useProducts, inr, buildLabel } from "../lib/api";
import { renderOf } from "./ProductCard";

export const SearchDialog = ({ open, onOpenChange }) => {
  const [q, setQ] = useState("");
  const [debounced, setDebounced] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    const t = setTimeout(() => setDebounced(q.trim()), 250);
    return () => clearTimeout(t);
  }, [q]);
  const { data = [], isFetching } = useProducts(debounced ? { q: debounced, limit: 6 } : { limit: 4 });

  const close = () => { onOpenChange(false); setQ(""); };
  const submit = (e) => {
    e.preventDefault();
    if (!q.trim()) return;
    navigate(`/shop?q=${encodeURIComponent(q.trim())}`);
    close();
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="top-[12%] max-w-xl translate-y-0 overflow-hidden rounded-2xl border-jute/60 bg-linen p-0 shadow-float">
        <DialogTitle className="sr-only">Search products</DialogTitle>
        <form onSubmit={submit} className="flex items-center gap-3 border-b border-jute/60 px-5 pr-12">
          <Search className="h-5 w-5 text-sheesham" />
          <input
            autoFocus value={q} onChange={(e) => setQ(e.target.value)} data-testid="search-input"
            placeholder="Search racks, modules, finishes..."
            className="h-14 min-w-0 flex-1 bg-transparent text-base outline-none placeholder:text-muted-foreground"
          />
        </form>
        <div className="max-h-[60vh] overflow-y-auto p-3">
          <p className="eyebrow px-2 pb-2 pt-1">{debounced ? (isFetching ? "Searching" : `${data.length} results`) : "Popular right now"}</p>
          {data.map((p) => (
            <Link key={p.slug} to={`/product/${p.slug}`} onClick={close} data-testid={`search-result-${p.slug}`} className="group flex items-center gap-4 rounded-xl p-2 transition-colors hover:bg-card">
              <div className="render h-14 w-14 rounded-lg"><img src={renderOf(p)} alt="" className="h-full w-full object-cover" /></div>
              <div className="flex-1">
                <p className="t-h4 leading-tight">{p.name}</p>
                <p className="t-small">{buildLabel(p.build_minutes)}</p>
              </div>
              <span className="price text-sm">{inr(p.price)}</span>
              <ArrowRight className="h-4 w-4 -translate-x-1 text-sheesham opacity-0 transition-[opacity,transform] group-hover:translate-x-0 group-hover:opacity-100" />
            </Link>
          ))}
          {debounced && !isFetching && data.length === 0 && (
            <p data-testid="search-empty" className="px-2 py-6 text-sm text-muted-foreground">Nothing matches "{debounced}". Try "rack" or "drawer".</p>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
